import styled, { css } from 'styled-components';
import { hex2rgba } from '@sainsburys-tech/boltui-utils';
var Tab = styled.a.withConfig({
  displayName: "Tabsstyles__Tab",
  componentId: "i644s4-0"
})(["width:100%;min-width:105px;text-align:center;padding:18px 16px;cursor:pointer;position:relative;outline:none;text-decoration:none;font-weight:", ";font-family:", ";font-size:", ";color:", ";border-bottom:1px solid ", ";", " ", " ", ";", ""], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return !props.disabled && props.isActive && css(["border-bottom:2px solid ", ";color:", ";font-weight:", ";&:hover{background-color:", ";color:", ";}"], props.theme.color.palette['brand-1'], props.theme.color.palette['brand-1'], props.theme.font.weight.bold, hex2rgba(props.theme.color.palette['brand-1-dark'], 0.06), props.theme.color.palette['brand-1-dark']);
}, function (props) {
  return props.disabled && css(["opacity:0.35;cursor:not-allowed;"]);
}, function (props) {
  return !props.disabled && !props.isActive && (props.fullBorder ? css([":hover{background-color:", ";color:", ";}"], hex2rgba(props.theme.color.monochrome.darker, 0.06), props.theme.color.monochrome.darker) : css([":hover{background-color:", ";color:", ";}"], hex2rgba(props.theme.color.monochrome.darker, 0.06), props.theme.color.monochrome.darker));
}, function (props) {
  return props.variant === 'pill' && css(["width:auto;text-align:center;display:inline;margin:12px auto;padding:7px 16px;border-radius:1000px;border:none;", ""], !props.disabled && props.isActive && css(["background-color:", ";color:", ";&:hover{background-color:", ";color:", ";}"], props.theme.color.palette['brand-1'], props.theme.color.monochrome.white, props.theme.color.palette['brand-1-dark'], props.theme.color.monochrome.white));
});
var Tabs = styled.div.withConfig({
  displayName: "Tabsstyles__Tabs",
  componentId: "i644s4-1"
})(["justify-content:space-between;align-content:center;display:flex;flex-grow:1;overflow-x:auto;width:100%;", " ", ""], function (props) {
  return css(["border-bottom:1px solid ", ";"], props.theme.color.monochrome.lighter);
}, function (props) {
  return props.fullBorder && css(["border-top:1px solid ", ";"], props.theme.color.monochrome.lighter);
});
var Content = styled.div.withConfig({
  displayName: "Tabsstyles__Content",
  componentId: "i644s4-2"
})(["margin-top:15px;"]);
export { Tab, Tabs, Content };